// Modalidades
(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const _domModalidades = document.querySelector(".modalidades");

    if (!_domModalidades) {
      return;
    }

    const _domModalidadesModal = document.querySelector(".modalidades_modal");
    const _domModalBtnAnterior = _domModalidadesModal.querySelector(
      ".btn_anterior"
    );
    const _domModalBtnProxima = _domModalidadesModal.querySelector(
      ".btn_proxima"
    );

    const _functionVisibilidadeBotoesNAvegacaoModal = (
      __domModalidadeAtivo
    ) => {
      const ___domPreviousElementSibling =
        __domModalidadeAtivo.previousElementSibling;
      const ___domNextElementSibling = __domModalidadeAtivo.nextElementSibling;

      window.requestAnimationFrame(() => {
        if (
          !___domPreviousElementSibling ||
          !___domPreviousElementSibling.classList.contains("modalidade")
        ) {
          _domModalBtnAnterior.classList.add("hidden");
        } else {
          _domModalBtnAnterior.classList.remove("hidden");
        }

        if (
          !___domNextElementSibling ||
          !___domNextElementSibling.classList.contains("modalidade")
        ) {
          _domModalBtnProxima.classList.add("hidden");
        } else {
          _domModalBtnProxima.classList.remove("hidden");
        }
      });
    };

    const _functionPararVideos = () => {
      try {
        _domModalidadesModal
          .querySelectorAll("video")
          .forEach((___video) => ___video.pause());
      } catch (error) {}
    };

    // Modalidades
    _domModalidades
      .querySelectorAll(".modalidade")
      .forEach((__domModalidade) => {
        // Open Modal
        __domModalidade
          .querySelector(".modalidade-titulo")
          .addEventListener("click", () => {
            const ___domModalModalidadeAtivo = _domModalidadesModal.querySelector(
              ".modalidade.ativo"
            );
            const ___domModalModalidade = _domModalidadesModal.querySelector(
              `#modal_${__domModalidade.id}`
            );

            window.requestAnimationFrame(() => {
              if (___domModalModalidadeAtivo) {
                ___domModalModalidadeAtivo.classList.remove("ativo");
              }

              ___domModalModalidade.classList.add("ativo");
              document.body.classList.add("open_modalidades");

              _functionVisibilidadeBotoesNAvegacaoModal(___domModalModalidade);
            });
          });
      });

    // Modalidades Modal
    _domModalidadesModal
      .querySelectorAll(".modalidade")
      .forEach((__domModalidade) => {
        // Media
        __domModalidade.querySelectorAll(".media").forEach((___media) => {
          ___media.addEventListener("click", (event) => {
            event.preventDefault();

            window.requestAnimationFrame(() => {
              __domModalidade
                .querySelector(".media.--principal")
                .classList.remove("--principal");
              ___media.classList.add("--principal");
            });
          });
        });
      });

    // Modal Fechar
    _domModalidadesModal
      .querySelector(".btn_fechar")
      .addEventListener("click", () => {
        window.requestAnimationFrame(() => {
          _functionPararVideos();

          document.body.classList.remove("open_modalidades");
        });
      });

    //  Modal Btn Anterior
    _domModalBtnAnterior.addEventListener("click", () => {
      const __domModalModalidadeAtivo = _domModalidadesModal.querySelector(
        ".modalidade.ativo"
      );

      if (!__domModalModalidadeAtivo) {
        return;
      }

      const __domPreviousElementSibling =
        __domModalModalidadeAtivo.previousElementSibling;

      if (
        !__domPreviousElementSibling ||
        !__domPreviousElementSibling.classList.contains("modalidade")
      ) {
        return;
      }

      window.requestAnimationFrame(() => {
        __domModalModalidadeAtivo.classList.remove("ativo");
        __domPreviousElementSibling.classList.add("ativo");

        _functionVisibilidadeBotoesNAvegacaoModal(__domPreviousElementSibling);

        _functionPararVideos();
      });
    });

    //  Modal Btn Proxima
    _domModalBtnProxima.addEventListener("click", () => {
      const __domModalModalidadeAtivo = _domModalidadesModal.querySelector(
        ".modalidade.ativo"
      );

      if (!__domModalModalidadeAtivo) {
        return;
      }

      const __domNextElementSibling =
        __domModalModalidadeAtivo.nextElementSibling;

      if (
        !__domNextElementSibling ||
        !__domNextElementSibling.classList.contains("modalidade")
      ) {
        return;
      }

      window.requestAnimationFrame(() => {
        __domModalModalidadeAtivo.classList.remove("ativo");
        __domNextElementSibling.classList.add("ativo");

        _functionVisibilidadeBotoesNAvegacaoModal(__domNextElementSibling);

        _functionPararVideos();
      });
    });
  });
})();
